// Cambiar a true para habilitar verificación parcial en todos los tenants.
const PARTIAL_VERIFICATION_GLOBAL_ENABLED = false;

const PARTIAL_VERIFICATION_TENANT_IDS = [
  '6952e2ae5d0d13b6a5b080c9', // Plastyverg
  '5ffc9b529e94bf0a6a9cde13', // Planiwise pruebas
];

const PARTIAL_VERIFICATION_ENUM_VALUES = ['partialRequested', 'partialVerified', 'notPartialVerified'];

export function canUsePartialVerification(tenantId?: string | null): boolean {
  if (PARTIAL_VERIFICATION_GLOBAL_ENABLED) {
    return true;
  }

  return Boolean(tenantId && PARTIAL_VERIFICATION_TENANT_IDS.includes(String(tenantId)));
}

export function filterPartialVerificationEnumValues(values: string[], enabled: boolean): string[] {
  if (enabled) {
    return values;
  }

  return values.filter((value) => !PARTIAL_VERIFICATION_ENUM_VALUES.includes(value));
}

export function filterPartialVerificationFilterOptions(values: string[], enabled: boolean): string[] {
  return filterPartialVerificationEnumValues(values, enabled).filter((value) => value !== 'partialRequested');
}

// Cambiar a true para aplicar "el verificador no puede ser ejecutor" en todos los tenants.
const PARTIAL_VERIFIER_NOT_EXECUTOR_GLOBAL_ENABLED = false;

const PARTIAL_VERIFIER_NOT_EXECUTOR_TENANT_IDS = [
  '6952e2ae5d0d13b6a5b080c9', // Plastyverg
];

export function shouldBlockVerifierAsExecutor(tenantId?: string | null): boolean {
  if (PARTIAL_VERIFIER_NOT_EXECUTOR_GLOBAL_ENABLED) {
    return true;
  }

  return Boolean(tenantId && PARTIAL_VERIFIER_NOT_EXECUTOR_TENANT_IDS.includes(String(tenantId)));
}

const getEntityId = (value: any) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const id = value.id ?? value._id;
  return id == null ? '' : String(id);
};

export function collectParcialExecutorIds(parcialOrTasks: any): string[] {
  const tasks = Array.isArray(parcialOrTasks) ? parcialOrTasks : parcialOrTasks?.tareasVinculadas || [];
  const ids = new Set<string>();
  (tasks || []).forEach((task: any) => {
    const id = getEntityId(task?.ejecutor);
    if (id) ids.add(id);
  });
  const extra = getEntityId(parcialOrTasks?.ejecutorTarea);
  if (extra) ids.add(extra);
  return Array.from(ids);
}

export function isUserExecutorOfParcial(parcialOrTasks: any, userId?: string | null): boolean {
  if (!userId) return false;
  return collectParcialExecutorIds(parcialOrTasks).includes(String(userId));
}

